import { render } from "./OutcomesReport.vue?vue&type=template&id=bc2637a2&scoped=true"
import script from "./OutcomesReport.vue?vue&type=script&lang=js"
export * from "./OutcomesReport.vue?vue&type=script&lang=js"

import "./OutcomesReport.vue?vue&type=style&index=0&id=bc2637a2&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2637a2"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QField});
